const PlatformSkeleton = ({ expanded }: { expanded: boolean }) => (
  <>
    {/* Platform header skeleton */}
    <li className={`px-3 py-1 ${expanded ? '' : 'text-center'}`}>
      <div className="animate-pulse">
        <div
          className={`h-3 bg-gray-600 rounded ${
            expanded ? 'w-16' : 'w-4 mx-auto'
          }`}
        ></div>
      </div>
    </li>
    {/* Platform items skeleton - show 1-2 items per platform */}
    <SocialItemSkeleton expanded={expanded} />
    <SocialItemSkeleton expanded={expanded} />
  </>
);

const SocialItemSkeleton = ({ expanded }: { expanded: boolean }) => (
  <li className="animate-pulse">
    <div
      className={`flex items-center w-full px-3 py-2 ${
        expanded ? '' : 'justify-center'
      }`}
    >
      {/* Profile picture skeleton */}
      <div className="w-8 h-8 relative flex-shrink-0">
        <div className="w-8 h-8 rounded-full bg-gray-700"></div>
        {/* Platform icon skeleton */}
        <div className="w-4 h-4 absolute bottom-0 right-0 rounded-full bg-gray-600"></div>
      </div>
      {/* Name skeleton - only show when expanded */}
      {expanded && (
        <div className="ml-3 overflow-hidden flex-1">
          <div className="h-4 bg-gray-700 rounded w-24"></div>
        </div>
      )}
    </div>
  </li>
);

export default PlatformSkeleton;
